import PropTypes from 'prop-types';
import { Button, DropDownButton } from '@progress/kendo-react-buttons';
import { Label } from '@progress/kendo-react-labels';
import { TabStrip, TabStripTab } from '@progress/kendo-react-layout';
import ConfirmationModal from 'commons/modal/ConfirmationModal';
import { default as Card } from 'commons/card/CollapsableCard';
import LoaderContainer from 'commons/container/LoaderContainer';
import React, { useEffect, useState } from 'react';
import 'scss/_projectDetail.scss';
import CampaignBuilder from './CampaignBuilder';
import { useSearchParams } from 'react-router-dom';
import { useAddCampagneMediaMutation, useGetMediasQuery, useLazyGetCampagneMediaQuery, useRemoveCampagneMediaMutation } from '../../../redux/api/cache';

export default function AddMedias(props) {
  const [deleteModalVisible, setDeleteModalVisible] = useState(false);
  const [defaultDropDownMedias, setdefaultDropDownMedias] = useState([]);
  const [selectedTab, setSelectedTab] = useState(0);
  const [dropDownMedias, setDropDownMedias] = useState(defaultDropDownMedias);
  const [getCampagneMedia, campagneMedia] = useLazyGetCampagneMediaQuery();
  const [addCampagneMedia] = useAddCampagneMediaMutation();
  const [removeCampagneMedia] = useRemoveCampagneMediaMutation();
  const [searchParams, setSearchParams] = useSearchParams();
  const setMedia = (medias) => {
    let media = searchParams.get("media");
    if (media && medias.length > 0 && medias.filter(mediaItem => mediaItem.inTabs).find(mediaElement => mediaElement.key === media)) {
      setSelectedTab(medias.filter(mediaItem => mediaItem.inTabs).findIndex(mediaItem => mediaItem.key === media));
    } else if (defaultDropDownMedias.length > 0) {
      searchParams.set("media", defaultDropDownMedias.filter(currentMedia => currentMedia.inTabs)[selectedTab].key);
      setSearchParams(searchParams, { replace: true });
    }
  };

  const { data: media } = useGetMediasQuery();

  useEffect(() => {
    setMedia(defaultDropDownMedias);
  }, [searchParams, defaultDropDownMedias]);

  const handleSelectedTab = (selected) => {
    if (defaultDropDownMedias.length > 0) {
      searchParams.set("media", defaultDropDownMedias.filter(currentMedia => currentMedia.inTabs)[selected].key);
      setSearchParams(searchParams, { replace: true });
    }
    setSelectedTab(selected);
  };

  useEffect(() => {
    async function fetchCampagneMedia() {
      let campagneMedias = await getCampagneMedia(props.data.camp_seq).unwrap();
      let newdefaultDropDownMedias = media.data.map((media) => {
        return ({
          descr: media.media_descr,
          key: media.media_cd,
          inTabs: campagneMedias.data.some(
            (campagne) => campagne.media_cd === media.media_cd
          ),
        });
      });
      newdefaultDropDownMedias.push({
        descr: 'Tout',
        key: 'Tout',
        inTabs: true,
      });

      let dropdown = newdefaultDropDownMedias.filter((tab) => !tab.inTabs);
      setdefaultDropDownMedias(newdefaultDropDownMedias);
      setDropDownMedias(dropdown);
    }
    if (media?.data)
      fetchCampagneMedia();
  }, [getCampagneMedia, media?.data, props.data.camp_seq]);

  const setActive = async (medias, item, bool) => {
    let newList = JSON.parse(JSON.stringify(medias));
    newList.find((data) => data.descr === 'Tout').inTabs = true;
    if (item.descr === 'Tout')
      newList.forEach((media) => (media.inTabs = bool));
    else
      newList.find((data) => data.descr === item.descr).inTabs = bool;

    let differences = newList.filter(
      (newitem) =>
        !medias.some(
          (media) =>
            media.key === newitem.key &&
            media.descr === newitem.descr &&
            media.inTabs === newitem.inTabs
        )
    );

    for (let i = 0; i < differences.length; i++) {
      if (differences[i].key !== "Tout") {
        if (differences[i].inTabs) {
          await addCampagneMedia({
            camp_seq: props.data.camp_seq,
            media_cd: differences[i].key,
          });
        } else {
          let result = await removeCampagneMedia({ seq: props.data.camp_seq, media: differences[i].key }).unwrap();
          if (!result.success)
            newList.find(
              (data) => result.data[0].media_cd === data.key
            ).inTabs = true;
        }
      }
    }
    return newList;
  };

  const onTabDelete = async (item) => {
    let tabs = await setActive(defaultDropDownMedias, item, false);
    let dropdown = tabs.filter((tab) => !tab.inTabs);
    setdefaultDropDownMedias(tabs);
    setDropDownMedias(dropdown);
  };

  const itemRender = (props) => <Label>{props.item.descr}</Label>;

  const onItemClick = async (e) => {
    let tabOptions = await setActive(defaultDropDownMedias, e.item, true);
    let dropDownMedia = tabOptions.filter((tabOption) => !tabOption.inTabs);
    setdefaultDropDownMedias(tabOptions);
    setDropDownMedias(dropDownMedia);
  };

  const Tabs = defaultDropDownMedias.map((item) =>
    item.inTabs && item.descr !== 'Tout' ? (
      <TabStripTab
        key={item.descr}
        title={
          <span>
            {item.descr}
          </span>
        }>
        <div className="inline">
          <div style={{ marginLeft: 'auto' }}></div>
          <Button
            icon={'close'}
            className="whiteButton"
            style={{
              margin: '2px',
              borderRadius: '50%',
              width: '34px',
              height: '34px',
              marginTop: '15px',
              marginRight: '15px'
            }}
            onClick={() => setDeleteModalVisible(true)}>
          </Button>
        </div>

        <CampaignBuilder
          key={item.descr + 'builder'}
          data={props.data}
          media={item} />
        {deleteModalVisible && (
          <ConfirmationModal
            text={`Fermer l'onglet ?`}
            onClose={() => {
              setDeleteModalVisible(false);
            }}
            onConfirm={() => {
              setDeleteModalVisible(false);
              onTabDelete(item);
            }} />
        )}
      </TabStripTab>
    ) : null
  );

  return campagneMedia?.data?.success && media.success ? (
    <div>
      <TabStrip
        animation={false}
        selected={selectedTab}
        onSelect={(e) => { handleSelectedTab(e.selected); searchParams.delete('campagne'); searchParams.delete('document'); setSearchParams(searchParams); }}
        style={{
          backgroundColor: 'white',
          margin: '0 15px 0 15px',
          padding: '0px 0px 0px 15px',
          borderTopLeftRadius: '15px',
        }}>
        {Tabs}
        {dropDownMedias.length > 0 && (
          <TabStripTab title={<span className='k-icon k-font-icon k-i-plus'/>}>
            <Card canCollapse={false}>
              <DropDownButton buttonClass='blueButton' title='Cliquer pour ajouter un média' text="Cliquer pour ajouter un média" items={dropDownMedias} itemRender={itemRender} onItemClick={onItemClick} icon='plus' />
            </Card>
          </TabStripTab>
        )}
      </TabStrip>
    </div>
  ) : (
    <LoaderContainer />
  );
}

AddMedias.propTypes = {
  item: PropTypes.shape({
    descr: PropTypes.any,
  }),
  data: PropTypes.shape({
    camp_seq: PropTypes.any,
  }),
};
